const subscription = {
    limit_exceeded: 'لقد وصلت إلى الحد الأقصى لخطة الاشتراك الخاصة بك.',
    get_plan_failed: 'غير قادر على الحصول على خطة الاشتراك للمستأجر.',
    tenant_suspended: 'تم تعليق المستأجر. يرجى الاتصال بالمسؤول الخاص بك.',
};
export default Object.freeze(subscription);
